import React, { useState } from 'react';
import { galleryImages } from '../mock';
import { X, ZoomIn } from 'lucide-react';

const GallerySection = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  return (
    <section className="py-32 bg-[#121212] relative" id="gallery">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 md:px-[7.6923%]">
        {/* Section Header */}
        <div className="mb-16 text-center">
          <p id="gallery-section-tab" className="section-tab">Visuals</p>
          <h2 id="gallery-section-title" className="section-title">Album Covers</h2>
        </div>

        {/* Gallery Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {galleryImages.map((image) => (
            <div
              key={image.id}
              className="group relative aspect-square overflow-hidden cursor-pointer dark-hover"
              onClick={() => setSelectedImage(image)}
            >
              <img
                src={image.url}
                alt={image.alt}
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                loading="lazy"
                onError={(e) => {
                  // Fallback if image fails to load
                  e.target.src = 'https://via.placeholder.com/800?text=Image+Not+Available';
                }}
              />
              {/* Overlay */}
              <div className="absolute inset-0 bg-black/60 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center">
                <div className="text-center space-y-2">
                  <ZoomIn className="text-brand-turquoise mx-auto" size={24} />
                  <p className="body-medium text-white">{image.caption}</p>
                </div>
              </div>
              {/* Bottom Label */}
              <div className="absolute bottom-0 left-0 right-0 p-4 bg-gradient-to-t from-black to-transparent">
                <p className="body-small text-white">{image.caption}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Lightbox Modal */}
      {selectedImage && (
        <div
          className="fixed inset-0 bg-black/95 z-50 flex items-center justify-center p-4"
          onClick={() => setSelectedImage(null)}
        >
          <button
            className="absolute top-8 right-8 text-white hover:text-brand-turquoise transition-colors p-2"
            onClick={() => setSelectedImage(null)}
            aria-label="Close"
          >
            <X size={24} />
          </button>
          <div className="max-w-5xl w-full" onClick={(e) => e.stopPropagation()}>
            <img
              src={selectedImage.url}
              alt={selectedImage.alt}
              className="w-full h-auto max-h-[80vh] object-contain"
              onError={(e) => {
                // Fallback if image fails to load
                e.target.src = 'https://via.placeholder.com/1200?text=Image+Not+Available';
              }}
            />
            <div className="mt-6 text-center">
              <p id="gallery-modal-title" className="subsection-title">{selectedImage.caption}</p>
              <p className="body-medium text-white/70 mt-2">{selectedImage.alt}</p>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default GallerySection;